import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import React, {useRef} from "react";
import RequestInformationForm from "./RequestInformationForm";
import { Grid } from "@material-ui/core";
import globalStyles from "./globalStyles";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";

/**
 * Building card form component that follows scroll
 * @classes {MUI styles}
 * @elementRefPaper {Ref to attach to this component}
 * @LanguageContext {The language content to translate form fields}
 * @buildingedit {Building data}
 * @elementRefCar {Reference to the carousel div, used to calculate correct position}
 * @elementRefBody {Reference to the body of the parent component, used to calculate correct position}
 *
 *  */

const useStyles = makeStyles((theme) => ({
    PaperSendRequestInfo: {
        position:"static",
        padding: "40px 20px",
        border: "1px solid #E5E5E5",
        boxSizing: "border-box",
        boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12)",
        borderRadius: "16px",
        width:"400px",
    },
    PaperSendRequestInfoBottom: {
        position:"absolute",
        bottom: "0px",
        padding: "40px 20px",
        border: "1px solid #E5E5E5",
        boxSizing: "border-box",
        boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12)",
        borderRadius: "16px",
        width:"400px",
    },
    PaperSendRequestInfoFixed: {
        position: "fixed",
        top: "84px",
        padding: "40px 20px",
        border: "1px solid #E5E5E5",
        boxSizing: "border-box",
        boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12)",
        borderRadius: "16px",
        width:"400px",
        maxHeight: '90vh',
        overflow: "auto",
    },

    buildingName: {
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: 24,
        lineHeight: "31px",
        color: "#000000",
    },

}));
const BuildingFormCard = ({
  elementRefPaper,
  LanguageContext,
  buildingedit,
  listunits,
  listCompany,
  elementRefCar,
  slug,
 footerRef,
}) => {
  const { dictionary } = React.useContext(LanguageContext);
  const [carouselCollider, setCarouselCollider] = React.useState(false);
  const [footerCollider, setFooterCollider] = React.useState(false);
    const classes = useStyles();
    const lastLinkRef = useRef(null);



    function getOverlapAmount(screenHeight = window.innerHeight) {
        const totalActualHeight = 810 + 272;
        const totalMaxHeight = screenHeight * 0.9 + 272;

        let overlap;

        if(screenHeight * 0.9 > 810) {
            overlap = totalActualHeight - screenHeight;
        } else {
            overlap = totalMaxHeight - screenHeight;
        }

        return overlap > 0 ? overlap : 0;
    }
    function isOverlapping(element1, element2) {
        const rect1 = element1.getBoundingClientRect();
        const rect2 = element2.getBoundingClientRect();

        return !(
            rect1.bottom < rect2.top ||
            rect1.top > rect2.bottom ||
            rect1.right < rect2.left ||
            rect1.left > rect2.right
        );
    }

    React.useEffect(() => {
        let lastScrollTop = 0;
        let overlapStartScrollPosition = null;
      const observer = new IntersectionObserver(
          (entries) => {
              entries.forEach((entry) => {
                  if (entry.target === elementRefCar.current) {
                      if (entry.isIntersecting) {
                          setCarouselCollider(true);
                      } else {
                          setCarouselCollider(false);
                      }
                   }
              });
          },
      );

        if (elementRefCar.current) {
            observer.observe(elementRefCar.current);
        }

      if (footerRef.current) {
          observer.observe(footerRef.current);
      }
        const handleScroll = () => {
            const overlapAmount = getOverlapAmount()
            if (lastLinkRef.current && footerRef && footerRef.current) {
                const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

                if (currentScrollTop > lastScrollTop) {
                    if (isOverlapping(lastLinkRef.current, footerRef.current)) {
                        setFooterCollider(true);
                        overlapStartScrollPosition = currentScrollTop;
                    }
                } else {
                    if (overlapStartScrollPosition && (overlapStartScrollPosition - currentScrollTop) >= overlapAmount) {
                        setFooterCollider(false);
                        overlapStartScrollPosition = null;
                    }
                }
                lastScrollTop = currentScrollTop;
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

  }, []);



    const getClassName = () => {
        if (carouselCollider) {
            return classes.PaperSendRequestInfo;
        }
        else if (footerCollider) {
            return classes.PaperSendRequestInfoBottom;
        }
        else {
            return classes.PaperSendRequestInfoFixed;
        }
    };







  return (
    <>

        <Paper
          ref={elementRefPaper}
          className={
              getClassName()
                        }
          elevation={3}
        >
          <Typography
            className={classes.buildingName}
            color="textSecondary"
            gutterBottom
          >
            {dictionary.regInfo}
          </Typography>

          {listCompany.length > 0 && (
            <Grid
              style={{ marginTop: "10px", marginBottom: "10px" }}
              container
              spacing={3}
            >
              {listCompany.map((company, index) => (
                <>
                  {index < 3 && (
                    <Grid xs={4} item>
                      <img
                        width="100%"
                        height="40px"
                        style={{ objectFit: "contain" }}
                        alt={`${company.companyname} Logo`}
                        src={company.logo}
                      />
                    </Grid>
                  )}
                </>
              ))}
            </Grid>
          )}

          <RequestInformationForm
            slug={slug}
            building={buildingedit}
            buildinglist={false}
            listunits={listunits}
          />
            <div ref={lastLinkRef}></div>
        </Paper>

    </>
  );
};

export default BuildingFormCard;
